module.exports = __webpack_public_path__ + "assets/media/arrow-down.a6eb8e20.svg";